// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__A123k","image":"index_image__c42p_"};